export default __webpack_public_path__ + "static/media/person-black-icon.7bb3ded3.svg";